// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__iFWQW","checkbox":"TodoItem_checkbox__Tf0FQ","textInput":"TodoItem_textInput__N9CPb"};